import { Locale, type LocalizedString } from "../Locale.js";
import { OrderDiscountType } from "../OrderDiscountType.js";

export const orderDiscountTypeNameMap: Record<OrderDiscountType, LocalizedString> = {
	[OrderDiscountType.Coupon]: {
		[Locale.cs]: "Slevový kód",
		[Locale.en]: "Discount code",
	},
	[OrderDiscountType.FathersFamily]: {
		[Locale.cs]: "Sleva Father’s Family",
		[Locale.en]: "Father’s Family discount",
	},
	[OrderDiscountType.B2bFirstOrder]: {
		[Locale.cs]: "Sleva na první objednávku",
		[Locale.en]: "First order discount",
	},
};
